// extracted by mini-css-extract-plugin
export default {"wrapper":"_1TzGr","heading":"_2m8Ii","descriptionContainer":"_2CNvW","ctaContainer":"_31ZAJ","separator":"aLYgB","lineBreak":"_1F4w-"};